module.exports = __webpack_public_path__ + "img/mobile-elbow-2_70x52.7e0a9aff.png";